import * as types from '../MutationTypes';

const state = {
  teams: [],
  schemaVersion: '2.0'
};

const getters = {
  teams: state => state.teams
};

const actions = {
  updateTeams ({ commit, state }, items) {
    commit(types.TEAMS_UPDATE, items);
  },
  clearCache ({ commit, state }) {
    commit(types.TEAMS_CLEAR);
  }
};

const mutations = {
  [types.TEAMS_UPDATE] (state, { items }) {
    if (items.length) {
      state.teams = items;
    }
  },
  [types.TEAMS_CLEAR] (state) {
    state.teams = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/TeamsCache.js